export default function getResource(label, vars = []) {
    const resources = {
        beautyTraits: 'Atouts beauté',
        beautyTraitsInclude: 'Les traits de beauté sur votre profil comprennent :',
        beautyPreferences: 'Préférences beauté',
        beautyPreferencesInclude: 'Les préférences beauté sur votre profil comprennent :',
        skinType: 'Type de peau',
        skinTone: 'Teint',
        skinConcerns: 'Préoccupations en matière de peau',
        ingredientPreferences: 'Préférences ingrédients',
        fragranceFamily: 'Famille de parfums',
        hairType: 'Type de cheveux',
        hairTexture: 'Texture des cheveux',
        hairConcerns: 'Problèmes de cheveux',
        hairColor: 'Colorant capillaire',
        shoppingPreferences: 'Préférences magasinage',
        favoriteBrands: 'Marques favorites',
        eyeColor: 'Couleur des yeux',
        colorIQ: 'Couleur Qi',
        beautyTraitsVisible: 'Qui peut voir les atouts beauté sur votre profil :',
        beautyPreferencesVisible: 'Les préférences beauté de votre profil sont visibles par :',
        everyone: 'Tout le monde',
        justMe: 'Juste moi',
        profile: 'Profil',
        yourProfileVisibleMe: 'Votre profil est visible pour : Juste moi',
        yourProfileVisibleEveryone: 'Votre profil est visible pour : Tout le monde',
        yourSkincareConcerns: 'Vos problèmes de peau et de cheveux sont toujours cachés dans votre profil de la collectivité. Les autres membres de la clientèle qui ont défini des préférences beauté semblables aux vôtres verront vos traits lorsque vous publiez une évaluation.',
        yourBeautyInsider: 'Vos pages Beauty Insider, Listes et Compte sont toujours privées.',
        forMoreInformation: 'Pour plus d’informations, consulter nos',
        privacyPolicy: 'Politique de confidentialité',
        and: 'et',
        termsOfUse: 'conditions d’utilisation de Sephora'
    };
    return resources[label];
}
